import { Component, Input, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { URLS } from '../../constant/interface';
import { TemplateService } from '../../services/template.service';
import { ModalHelper } from '@delon/theme';
import { SmartGroupComponent } from '../smart-group/smart-group.component';
import { deepCopy } from '@delon/util';
import { DialogService } from '../../services/dialog.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-tpl-condition',
  template: `
    <ng-container *ngIf="source.useTmplMethod !== 2">
      <nz-form-item>
        <nz-form-label [nzSpan]="3">默认执行</nz-form-label>
        <nz-form-control [nzSpan]="15">
          <label [(ngModel)]="item.isDefault" nz-checkbox [name]="'isDefault' + index" [nzDisabled]="hasDefaultTemplate && !item.isDefault"></label>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item [hidden]="item.isDefault">
        <nz-form-label [nzSpan]="3">执行条件</nz-form-label>
        <nz-form-control [nzSpan]="16">
          <div class="steps-content" style="width: 100%;align-items: flex-start;flex-direction: column;" nz-row>
            <button acl [acl-ability]="'smartCusGroup.customerGroup.list'" nz-button nzType="link" type="button" title="获取智能客群条件" type="button" (click)="openSmartCustGroup(item)" style="padding:0">
              获取智能客群条件
            </button>
            <app-condition style="width: 100%;" [conditions]="item.conditions || []" [sIndex]="index" mode="edit" [variableBinds]="source.variableBinds" [tagUrl]="tagUrl" #condition></app-condition>
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item *ngIf="!item.isDefault && item.conditions && item.conditions.length > 1">
        <nz-form-label [nzSpan]="3">逻辑关系</nz-form-label>
        <nz-form-control [nzSpan]="15">
          <nz-radio-group [(ngModel)]="item.operateType" name="operateType">
            <label nz-radio nzValue="1">“与”关系</label>
            <label nz-radio nzValue="2">“或”关系</label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>
    </ng-container>
  `,
})
export class IccTplConditionComponent implements OnInit {
  /** 消息类型 */
  @Input() type: any;
  /** 当前模板的索引 */
  @Input() index: number;

  @ViewChild('condition', { static: false }) condition;
  /** 当前消息类型的资源 */
  source: any;
  /** 当前消息类型下的模板 */
  item: any;

  /** 辅助 - 标签地址 */
  tagUrl = URLS.templateTag.url;
  // /** 是否有默认模板 */
  get hasDefaultTemplate() {
    return this.source.templates.some((v: { isDefault: any }) => v.isDefault);
  }

  constructor(private modal: ModalHelper, private templateService: TemplateService, private dialogService: DialogService, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.source = this.templateService.getMsg(this.type) || [];
    this.item = this.templateService.getTpl(this.type)[this.index] || [];
    this.item.operateType += '';
  }

  openSmartCustGroup(item) {
    const { conditions } = item;
    if (this.condition.editIndex !== -1) {
      this.dialogService.notification.error('执行条件', '请先保存正在编辑的执行条件!');
      return;
    }
    this.modal.createStatic(SmartGroupComponent, { initConditions: conditions, size: 'lg' }).subscribe(data => {
      if (data.length > 8) {
        this.dialogService.notification.error('执行条件', '执行条件数量不能超过8个!');
      } else {
        item.conditions = deepCopy(data);
      }
    });
  }
}
